import type { StyleRule } from '@archipro-design/aria';
import { messageTooltipContentClassName } from '@archipro-design/aria';
import { hex2rgba } from '~/utils/colorHelper';

/** Matches Aria Button size={30} icon footprint (pxToRem(30) ≈ 1.875rem). */
const EDIT_MODE_ICON_SIZE = '1.875rem';

export const ActionButton: StyleRule = ({ theme }) => ({
    boxShadow: `0px 14px 24px 2px ${hex2rgba(
        theme.siteVariables.colors.primitive.black,
        0.08,
    )}`,
});

/** Hides the pencil while it still reserves layout space under Aria's absolute loader. */
export const ActionButtonHiddenIcon: StyleRule = () => ({
    opacity: 0,
});

/**
 * Aria's loader is absolutely positioned; force its icon to the same size={30} box as the pencil.
 */
export const ActionButtonNavigating: StyleRule = () => ({
    '& .ui-button__loader .ui-icon': {
        width: EDIT_MODE_ICON_SIZE,
        height: EDIT_MODE_ICON_SIZE,
    },
    '& .ui-button__loader .ui-icon svg': {
        width: EDIT_MODE_ICON_SIZE,
        height: EDIT_MODE_ICON_SIZE,
    },
});

export const TooltipContent: StyleRule = ({ theme }) => ({
    zIndex: theme.siteVariables.zIndexes.foreground,
    [`&.${messageTooltipContentClassName}`]: {
        maxWidth: 'unset',
        textAlign: 'center',
    },
});

export const Copied: StyleRule = ({ theme }) => ({
    fill: theme.siteVariables.colors.success['200'],
});
